import { omitPiiFromQueryString } from 'modules/shared/utils/piiQueryParams';

const UUID_PATTERN = /[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}/gi;

/**
 * Redacts UUID path segments and denylisted query params from a Next.js asPath-style string.
 */
export const sanitizePathForDatadog = (asPath: string): string => {
  const hashIndex = asPath.indexOf('#');
  const pathAndQuery = hashIndex >= 0 ? asPath.slice(0, hashIndex) : asPath;
  const hash = hashIndex >= 0 ? asPath.slice(hashIndex) : '';

  const queryIndex = pathAndQuery.indexOf('?');
  const pathname = queryIndex >= 0 ? pathAndQuery.slice(0, queryIndex) : pathAndQuery;
  const query = queryIndex >= 0 ? pathAndQuery.slice(queryIndex + 1) : '';

  const pathWithRedactedIds = pathname.replace(UUID_PATTERN, '?');

  if (!query) {
    return pathWithRedactedIds + hash;
  }

  const sanitizedQuery = omitPiiFromQueryString(query);
  const sanitizedPath = sanitizedQuery ? `${pathWithRedactedIds}?${sanitizedQuery}` : pathWithRedactedIds;

  return sanitizedPath + hash;
};

/**
 * Sanitizes absolute or relative URLs for Datadog view events.
 */
export const sanitizeUrlForDatadog = (url: string): string => {
  try {
    const parsed = new URL(url, 'https://placeholder.local');
    const isAbsolute = /^https?:\/\//i.test(url);
    const sanitizedPath = sanitizePathForDatadog(parsed.pathname + parsed.search + parsed.hash);

    return isAbsolute ? `${parsed.origin}${sanitizedPath}` : sanitizedPath;
  } catch {
    return sanitizePathForDatadog(url);
  }
};
